export const state = {
    locales: [],
}

export const mutations = {
    ADD_LOCALE(state, locale) {   
        const locales = state.locales 
        locales.push(locale)
        state.locales = [ ...new Set(locales) ]
    },
}

export const actions = {
    addLocale({ commit }, data) {
        commit('ADD_LOCALE', data.locale)
    },
}

export const getters = {
    locales: (state) => {
        return state.locales
    },
}